module.exports = __webpack_public_path__ + "img/Hat04_U2_5.3631c36a.svg";